<template>
	<div class="formTabWrapper">
		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Notes</div>
				<div class="formTabTableWrap_top-add">

					<v-btn
							:disabled="getPermissionAction" @click="onNotesDrawer(true)" type="button"
							depressed
							class="mainBtn mainBtn-text"
					>
						<span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Add note</span>
					</v-btn>

				</div>
			</div>
			<div class="formTabTableWrap_body">
				<notes
						v-if="truckNotesFilter"
						:filter="truckNotesFilter"
						:items="truckNotesList"
						:truckId="truckId"
						:getPermissionAction="getPermissionAction"
						@updateEdit="onEdit"
						@updateRemoveItem="setRemoveItem"
				></notes>
			</div>
		</div>

		<notes-drawer
				v-if="isNotesDrawer"
				:editItem="editItem"
				@closeDrawer="onNotesDrawer(false)"
				@updateSave="onSave"
		></notes-drawer>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="isRemove = false"
		></remove-block>
	</div>

</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import Notes from "@/components/Maintenance/Trucks/TruckForm/Notes/Notes";
// async components
const NotesDrawer =
		() => import("@/shared/Drawers/NotesDrawer/NotesDrawer");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");

export default {
	name: "FourthTab",
	components: {
		Notes,
		NotesDrawer,
		RemoveBlock
	},
	computed: mapGetters([ 'truckNotesFilter', 'truckNotesList' ]),
	props: {
		truckId: Number,
		getPermissionAction: Boolean
	},
	data: () => ({
		isNotesDrawer: false,
		editItem: null,
		isRemove: false,
		removeItem: null,
	}),
	methods: {
		...mapActions([ 'onTruckNotes', 'onTruckNotesCreate', 'onTruckNotesRemove' ]),
		async onSave(values) {
			await this.onTruckNotesCreate({ truckId: this.truckId, values });
			this.isNotesDrawer = false;
			this.editItem = null;
		},
		onNotesDrawer(value) {
			this.isNotesDrawer = value;
			if (!value) this.editItem = null;
		},
		async onEdit(item) {
			this.editItem = item;
			this.isNotesDrawer = true;
		},
		async setRemoveItem(id) {
			this.removeItem = { truckId: this.truckId, id };
			this.isRemove = true;
		},
		async onRemoveItem() {
			await this.onTruckNotesRemove(this.removeItem);
			this.isRemove = false;
		}
	},
	async mounted() {
		await this.onTruckNotes(this.truckId);
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabTableWrap";
</style>
